import { useCallback, useEffect, useState } from 'react';
import type { ReservationInfo } from '../api/reservationInfo';
import { fetchReservationInfo } from '../api/reservationInfo';

export const useReservationInfo = (tripId: string) => {
  const [reservationInfo, setReservationInfo] = useState<ReservationInfo | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!tripId || tripId === 'new') {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const info = await fetchReservationInfo(tripId);
      setReservationInfo(info);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[useReservationInfo] Failed to fetch:', e);
    } finally {
      setLoading(false);
    }
  }, [tripId]);

  useEffect(() => {
    load();
  }, [load]);

  const refetch = useCallback(async () => {
    if (!tripId || tripId === 'new') {
      return;
    }
    try {
      const info = await fetchReservationInfo(tripId);
      setReservationInfo(info);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[useReservationInfo] Failed to refetch:', e);
    }
  }, [tripId]);

  return { reservationInfo, loading, refetch };
};
